export const pattern = {
  /**
   * string without whitespaces at the beginning and the end
   */
  words: /^(?:[^\s]|(?:[^\s])(?:.+)?(?:[^\s]))$/im,
  email: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,18}$/i,
  price: /^(?:(0|[1-9]{1}\d{0,4})([.]\d{1,2})?|100000|100000\.0{1,2})$/,
  fmvAndBookValues: /^(?:(0|[1-9]{1}\d{0,5})([.]\d{1,2})?|1000000|1000000\.0{1,2})$/,
  percentage: /^(100|[0-9]{1,2}|[0-9]{1,2}\.[0-9]{1,2})$/,
  na: /^(?!N\/A$).*/i,
};
